import { render } from "./ToDeliver.vue?vue&type=template&id=7117673a&scoped=true"
import script from "./ToDeliver.vue?vue&type=script&lang=js"
export * from "./ToDeliver.vue?vue&type=script&lang=js"

import "./ToDeliver.vue?vue&type=style&index=0&id=7117673a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7117673a"]])

export default __exports__